function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
var _require = require('./supply-rows'),
  SUPPLY_BLOCK_COUNT = _require.SUPPLY_BLOCK_COUNT;
var _require2 = require('./supply-format'),
  formatSupplyTable = _require2.formatSupplyTable;
var _require3 = require('./block-statistics'),
  buildBlockStatistics = _require3.buildBlockStatistics;
var _require4 = require('./supply-deltas'),
  hasGoldenTicket = _require4.hasGoldenTicket;
function normalizeBlockId(value) {
  if (value == null || value === '') {
    return '—';
  }
  return String(value);
}
function dbRowToStatsRow(dbRow) {
  if (!dbRow) {
    return null;
  }
  return {
    block_id: dbRow.block_id,
    block_hash: dbRow.block_hash,
    previous_block_hash: dbRow.previous_block_hash || null,
    treasury: dbRow.treasury,
    graveyard: dbRow.graveyard,
    previous_block_unpaid: dbRow.previous_block_unpaid,
    total_fees: dbRow.total_fees,
    utxo: dbRow.utxo,
    total_supply: dbRow.total_supply,
    calculated_total_supply: dbRow.calculated_total_supply,
    utxo_graveyard_treasury_total: dbRow.utxo_graveyard_treasury_total,
    has_golden_ticket: dbRow.has_golden_ticket,
    total_payout_routing: dbRow.total_payout_routing,
    total_payout_mining: dbRow.total_payout_mining,
    total_payout_treasury: dbRow.total_payout_treasury,
    total_payout_graveyard: dbRow.total_payout_graveyard,
    total_payout_atr: dbRow.total_payout_atr,
    total_fees_new: dbRow.total_fees_new,
    total_fees_atr: dbRow.total_fees_atr,
    total_fees_cumulative: dbRow.total_fees_cumulative,
    fee_per_byte: dbRow.fee_per_byte,
    burn_fee: dbRow.burn_fee,
    difficulty: dbRow.difficulty
  };
}
function buildPresentationColumns() {
  var statsRows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return statsRows.map(function (row) {
    return {
      blockId: normalizeBlockId(row.block_id),
      blockHash: String(row.block_hash || ''),
      hasGoldenTicket: hasGoldenTicket(row)
    };
  });
}
function resolveStatsForBlock(_x, _x2, _x3, _x4) {
  return _resolveStatsForBlock.apply(this, arguments);
}
/**
 * Build a presentation-ready Token Supply accounting view.
 */
function _resolveStatsForBlock() {
  _resolveStatsForBlock = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(app, mod, block, dbRow) {
    var row;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          row = null;
          if (!dbRow) {
            _context.n = 1;
            break;
          }
          row = dbRowToStatsRow(dbRow);
          _context.n = 3;
          break;
        case 1:
          _context.n = 2;
          return buildBlockStatistics(app, mod, block);
        case 2:
          row = _context.v;
        case 3:
          if (row && block) {
            row.previous_block_hash = String(block.previousBlockHash || '').trim() || null;
          }
          return _context.a(2, row);
      }
    }, _callee);
  }));
  return _resolveStatsForBlock.apply(this, arguments);
}
function buildSupplyView(_x5, _x6) {
  return _buildSupplyView.apply(this, arguments);
}
function _buildSupplyView() {
  _buildSupplyView = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(app, mod) {
    var requestedCount,
      count,
      chainBlocks,
      hashes,
      dbRows,
      rowMap,
      statsRows,
      i,
      block,
      columns,
      rows,
      _args2 = arguments,
      _t,
      _t2;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.p = _context2.n) {
        case 0:
          requestedCount = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : SUPPLY_BLOCK_COUNT;
          count = Number.isFinite(requestedCount) ? Math.min(Math.max(Math.floor(requestedCount), 1), 20) : SUPPLY_BLOCK_COUNT;
          if (mod !== null && mod !== void 0 && mod.database) {
            _context2.n = 1;
            break;
          }
          throw new Error('explorer database unavailable');
        case 1:
          chainBlocks = [];
          _context2.p = 2;
          _context2.n = 3;
          return app.core.blockchain.getBlocks(count, false);
        case 3:
          chainBlocks = _context2.v;
          _context2.n = 5;
          break;
        case 4:
          _context2.p = 4;
          _t = _context2.v;
          console.error('Explorer: failed to read longest-chain blocks for supply', _t);
          throw new Error('failed to read longest-chain blocks');
        case 5:
          if (!(!Array.isArray(chainBlocks) || !chainBlocks.length)) {
            _context2.n = 6;
            break;
          }
          return _context2.a(2, {
            count: count,
            hasData: false,
            columns: [],
            rows: []
          });
        case 6:
          hashes = chainBlocks.map(function (block) {
            return block === null || block === void 0 ? void 0 : block.hash;
          }).filter(Boolean);
          _context2.n = 7;
          return mod.database.getStatisticsByBlockHashes(hashes);
        case 7:
          dbRows = _context2.v;
          rowMap = new Map(dbRows.map(function (row) {
            return [row.block_hash, row];
          }));
          statsRows = [];
          i = 0;
        case 8:
          if (!(i < chainBlocks.length)) {
            _context2.n = 12;
            break;
          }
          block = chainBlocks[i];
          if (block !== null && block !== void 0 && block.hash) {
            _context2.n = 9;
            break;
          }
          return _context2.a(3, 11);
        case 9:
          _t2 = statsRows;
          _context2.n = 10;
          return resolveStatsForBlock(app, mod, block, rowMap.get(block.hash));
        case 10:
          _t2.push.call(_t2, _context2.v);
        case 11:
          i++;
          _context2.n = 8;
          break;
        case 12:
          // getBlocks returns newest-first; display left-to-right as low block id → high.
          statsRows.reverse();
          columns = buildPresentationColumns(statsRows);
          _context2.n = 13;
          return formatSupplyTable(statsRows, {
            mod: mod,
            toStatsRow: dbRowToStatsRow
          });
        case 13:
          rows = _context2.v;
          return _context2.a(2, {
            count: count,
            hasData: columns.length > 0,
            columns: columns,
            rows: rows
          });
      }
    }, _callee2, null, [[2, 4]]);
  }));
  return _buildSupplyView.apply(this, arguments);
}
module.exports = {
  buildSupplyView: buildSupplyView,
  dbRowToStatsRow: dbRowToStatsRow
};